import { render, staticRenderFns } from "./RandomFact.vue?vue&type=template&id=75c00fc2&scoped=true"
import script from "./RandomFact.vue?vue&type=script&lang=js"
export * from "./RandomFact.vue?vue&type=script&lang=js"
import style0 from "./RandomFact.vue?vue&type=style&index=0&id=75c00fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c00fc2",
  null
  
)

export default component.exports